/**
 * Desktop mega menu — hover intent (LensDirect-style timing).
 * Open after brief dwell; stay open while moving into panel; close after grace period.
 */
(function () {
  const OPEN_DELAY_MS = 120;
  const CLOSE_DELAY_MS = 300;
  const DESKTOP_MQ = '(min-width: 990px)';

  function initHpMegaMenu(root) {
    const nav = root.querySelector('.hp-nav');
    if (!nav || nav.dataset.hpMegaBound === 'true') return;

    const mq = window.matchMedia(DESKTOP_MQ);
    const items = Array.from(nav.querySelectorAll('.hp-nav__item'));
    if (!items.length) return;

    nav.dataset.hpMegaBound = 'true';

    let openTimer = null;
    let closeTimer = null;
    let activeItem = null;

    function clearOpenTimer() {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
    }

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function clearTimers() {
      clearOpenTimer();
      clearCloseTimer();
    }

    function setExpanded(item, expanded) {
      const trigger = item.querySelector('.hp-nav__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function closeAll() {
      items.forEach((item) => {
        item.classList.remove('is-mega-open');
        setExpanded(item, false);
      });
      activeItem = null;
    }

    function openItem(item) {
      if (!mq.matches) return;
      if (activeItem === item && item.classList.contains('is-mega-open')) return;

      items.forEach((el) => {
        const isActive = el === item;
        el.classList.toggle('is-mega-open', isActive);
        setExpanded(el, isActive);
      });
      activeItem = item;
    }

    function scheduleOpen(item) {
      if (!mq.matches) return;
      clearCloseTimer();
      if (activeItem === item && item.classList.contains('is-mega-open')) return;

      clearOpenTimer();
      openTimer = window.setTimeout(() => {
        openTimer = null;
        openItem(item);
      }, OPEN_DELAY_MS);
    }

    function scheduleClose() {
      if (!mq.matches) return;
      clearOpenTimer();
      clearCloseTimer();
      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        if (nav.matches(':hover')) return;
        closeAll();
      }, CLOSE_DELAY_MS);
    }

    function onEnterZone(item) {
      scheduleOpen(item);
    }

    function onMegaEnter(item) {
      if (!mq.matches) return;
      clearCloseTimer();
      if (!item.classList.contains('is-mega-open')) {
        scheduleOpen(item);
      } else {
        activeItem = item;
      }
    }

    items.forEach((item) => {
      const mega = item.querySelector('.hp-mega');
      const trigger = item.querySelector('.hp-nav__trigger');

      item.addEventListener('mouseenter', () => onEnterZone(item));
      item.addEventListener('mouseleave', scheduleClose);

      if (mega) {
        mega.addEventListener('mouseenter', () => onMegaEnter(item));
        mega.addEventListener('mouseleave', scheduleClose);
      }

      if (trigger) {
        trigger.addEventListener('focus', () => {
          if (!mq.matches) return;
          clearTimers();
          openItem(item);
        });

      }

      item.addEventListener('focusout', (event) => {
        if (!mq.matches) return;
        const next = event.relatedTarget;
        if (next && item.contains(next)) return;
        scheduleClose();
      });
    });

    nav.addEventListener('mouseleave', scheduleClose);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!activeItem) return;
      clearTimers();
      closeAll();
    });

    mq.addEventListener('change', () => {
      clearTimers();
      closeAll();
    });
  }

  function boot() {
    document.querySelectorAll('[data-hp-header-mega]').forEach(initHpMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
